export const JiraAlignMarkBrand = () => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.71802 9.71777C9.71802 15.1008 14.101 19.4648 19.479 19.4648H28.52V28.5348H38.281V11.2608C38.281 10.4088 37.591 9.71777 36.74 9.71777H9.71802Z"
			fill="url(#paint0_linear_818_552)"
		/>
		<path
			d="M38.282 38.2818C38.282 32.8988 33.899 28.5348 28.521 28.5348H19.48V19.4648H9.71802V36.7388C9.71802 37.5908 10.408 38.2818 11.259 38.2818H38.282Z"
			fill="url(#paint1_linear_818_552)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_818_552"
				x1="21.692"
				y1="31.0018"
				x2="23.912"
				y2="19.5788"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.15" stopColor="#0055CC" />
				<stop offset="0.522" stopColor="#0B63DE" />
				<stop offset="1" stopColor="#1D7AFC" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_818_552"
				x1="26.308"
				y1="16.9978"
				x2="24.088"
				y2="28.4208"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.15" stopColor="#0055CC" />
				<stop offset="0.522" stopColor="#0B63DE" />
				<stop offset="1" stopColor="#1D7AFC" />
			</linearGradient>
		</defs>
	</svg>
);
